const products = [
  {
    id: 'vpn',
    badge: 'Privacy & Security',
    name: 'VPN',
    tagline: 'Total Privacy. Zero Compromise.',
    description:
      'Our VPN application provides industry-grade encryption to shield your internet traffic from prying eyes. Whether on public Wi-Fi or your home network, stay protected with a single tap. Designed for iOS with a clean, intuitive interface and blazing-fast server connections.',
    highlights: ['AES-256 Encryption', 'No-Logs Policy', 'One-Tap Connection', 'Global Server Network'],
    icon: 'ri-lock-line',
    img: 'https://public.readdy.ai/ai/img_res/dcc8d2bd7540f1339640ececaabdfa03.jpg',
    accent: 'from-emerald-500/20 to-teal-500/10',
    iconBg: 'bg-emerald-500/10 text-emerald-500',
  },
  {
    id: 'cleaner',
    badge: 'Performance',
    name: 'Cleaner',
    tagline: 'Optimized. Fast. Clean.',
    description:
      'Reclaim your iPhone&apos;s full potential with our smart Cleaner app. It intelligently scans for junk files, duplicate media, and unnecessary caches, freeing up valuable storage and improving your device performance — all in a matter of seconds.',
    highlights: ['Smart Junk Detection', 'Duplicate Photo Finder', 'Cache Cleaner', 'Storage Analyzer'],
    icon: 'ri-speed-up-line',
    img: 'https://readdy.ai/api/search-image?query=abstract%20mobile%20device%20optimization%20and%20cleaning%20concept%20art%2C%20circular%20energy%20burst%20effect%20in%20teal%20and%20white%20tones%2C%20dark%20charcoal%20background%20with%20glowing%20particles%20suggesting%20speed%20and%20performance%20improvement%2C%20minimal%20digital%20illustration%20no%20text&width=600&height=400&seq=cleaner-product-001&orientation=landscape',
    accent: 'from-teal-500/20 to-cyan-500/10',
    iconBg: 'bg-teal-500/10 text-teal-500',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="bg-[#0c0e12] py-28 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 text-white/50 text-xs font-semibold tracking-widest uppercase rounded-full px-4 py-1.5 mb-5">
            Our Products
          </div>
          <h2 className="text-4xl xl:text-5xl font-extrabold text-white mb-4">
            Security Solutions for iOS
          </h2>
          <p className="text-white/50 text-lg max-w-xl mx-auto leading-relaxed">
            Two powerful applications built to protect, optimize, and enhance your iOS experience.
          </p>
        </div>

        {/* Products */}
        <div className="flex flex-col gap-12">
          {products.map((product, idx) => (
            <div
              key={product.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${
                idx % 2 !== 0 ? 'lg:grid-flow-col-dense' : ''
              }`}
            >
              {/* Image */}
              <div className={`rounded-2xl overflow-hidden h-[320px] bg-gradient-to-br ${product.accent} ${idx % 2 !== 0 ? 'lg:order-2' : ''}`}>
                <img
                  src={product.img}
                  alt={`${product.name} product`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className={idx % 2 !== 0 ? 'lg:order-1' : ''}>
                <span className={`inline-block text-xs font-semibold tracking-widest uppercase rounded-full px-3 py-1 mb-4 ${product.iconBg}`}>
                  {product.badge}
                </span>
                <h3 className="text-4xl font-extrabold text-white mb-2">{product.name}</h3>
                <p className="text-emerald-400 font-medium text-lg mb-4">{product.tagline}</p>
                <p className="text-white/55 leading-relaxed text-base mb-7">
                  {product.id === 'cleaner'
                    ? "Reclaim your iPhone's full potential with our smart Cleaner app. It intelligently scans for junk files, duplicate media, and unnecessary caches, freeing up valuable storage and improving your device performance — all in a matter of seconds."
                    : product.description}
                </p>
                <ul className="flex flex-wrap gap-3">
                  {product.highlights.map((h) => (
                    <li
                      key={h}
                      className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5 text-white/70 text-sm whitespace-nowrap"
                    >
                      <i className="ri-check-line text-emerald-400 text-xs" />
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
